// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"117":"024d1cfb","249":"8ccd1eec","453":"2b9e5af2","554":"6ee21802","878":"cc99c90a","914":"1281fbb0"}[chunkId] + ".chunk.js";
};